/**
 * Derived readings over the same dataset: what a country is good at.
 *
 * There was a third — an "Ecosystem at a glance" panel with counts of companies,
 * universities and government bodies. Those numbers were invented by a seeded
 * generator and labelled as estimates, which was defensible while every score in
 * the atlas was invented too. It is not defensible now that the assessments are
 * real: a reader has no way to tell which figures on the page are measured, and
 * a caption is a weak defence against a number set in a large face. Removed
 * rather than relabelled; it comes back when there is an organisation directory
 * behind it.
 *
 * The "complementary partners" ranking that used to live here is gone; see
 * shared/src/gaps.ts for what replaced it and why the ranking was the wrong
 * question rather than the wrong formula.
 */
import { CATS_ALL } from './model.js';

export function highlights(c) {
  const list = CATS_ALL.map(x => ({ ...x, v: c.cat[x.d + '|' + x.c] })).sort((a, b) => b.v - a.v);
  const strengths = list.slice(0, 3);
  const gaps = list.slice(-3).sort((a, b) => a.v - b.v);
  const used = new Set([...strengths, ...gaps].map(x => x.d + x.c));
  const emerging = list.filter(x => !used.has(x.d + x.c))
    .map(x => ({ ...x, dist: Math.abs(x.v - 2) })).sort((a, b) => a.dist - b.dist).slice(0, 3);
  return { strengths, emerging, gaps };
}
